<!-- component-container has the background-image. layer applies darkening, content is the actual page content. -->
<div class="background-image-container">
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
</div>
